import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { PublicLayout } from '@/components/layout/PublicLayout';

import Error404 from "./errors/404";
import Error403 from "./errors/403";
import Error500 from "./errors/500";
import NetworkError from "./errors/NetworkError";

const withLayout = (layout: React.FC<{ children: React.ReactNode }>, component: React.ReactElement) => {
  const Layout = layout;
  return <Layout>{component}</Layout>;
};

export const ErrorPage = () => {
  const { t } = useTranslation(['errors']);
  useDocumentTitle(t('general.title'));
  const error = useRouteError();

  // Route errors like 404/403
  if (isRouteErrorResponse(error)) {
    switch (error.status) {
      case 403:
        return withLayout(PublicLayout, <Error403 />);
      case 404:
        return withLayout(PublicLayout, <Error404 />);
      default:
        return withLayout(PublicLayout, <Error500 />);
    }
  }

  // Network or unexpected errors
  return withLayout(PublicLayout, <NetworkError error={error} />);
};